import { ADD_INGREDIENTS_IN_GROCERY_LIST_RECIPE } from "./actionTypes";

export default (ingredientName: String, recipeId: Number, options) => ({
  type: ADD_INGREDIENTS_IN_GROCERY_LIST_RECIPE,
  payload: {
    ingredientName,
    recipeId,
    ...options
  },
});